import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=5028c988&scoped=true&"
var script = {}
import style0 from "./Face.vue?vue&type=style&index=0&id=5028c988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028c988",
  null
  
)

export default component.exports